export const AGENTS_RESET_STATE = 'AGENTS_RESET_STATE';
export const AGENTS_CURRENT_ITEM = 'AGENTS_CURRENT_ITEM';

export const AGENTS_REQUEST_LOADING = 'AGENTS_REQUEST_LOADING';
export const AGENTS_REQUEST_SUCCESS = 'AGENTS_REQUEST_SUCCESS';
export const AGENTS_REQUEST_FAILED = 'AGENTS_REQUEST_FAILED';

export const AGENTS_CURRENT_ACTION = 'AGENTS_CURRENT_ACTION';
export const AGENTS_RESET_ACTION = 'AGENTS_RESET_ACTION';